import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * The class-name merge helper shadcn/ui generates against. Kept at the path its
 * CLI expects (`@/lib/utils`) so components added later resolve it unchanged.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
